import { messagingConfig } from "./message";

export const config = {
  messagingConfig: messagingConfig,
};
